import {Component, FontAwesomeIcon} from 'substance'
import {NilUUID} from '../../../lib/utils/NilUUID'
import Author from './Author'

class AddToBylineComponent extends Component {

    constructor(...args) {
        super(...args)

        this.addAuthor = this.addAuthor.bind(this)
        this.createAuthor = this.createAuthor.bind(this)
    }

    didMount() {
        this.context.editorSession.onRender('document', this._onDocumentChange, this)
    }

    dispose() {
        this.context.editorSession.off(this)
    }

    _onDocumentChange(change) {
        if (change.isAffected(this.props.node.id) || change.isAffected(this.props.node.imageFile)) {
            this.rerender()
        }
    }

    render($$) {
        const el = $$('div')
            .ref('authorContainer')
            .addClass('authors dialog-image-info clearfix')
        const placeholderText = this.getLabel('Add to byline')
        let searchComponent

        if (this.props.bylineSearch) {
            const AuthorSearchComponent = this.context.configurator.getComponent('UIFormSearch')
            searchComponent = $$(AuthorSearchComponent, {
                existingItems: this.props.node.authors,
                conceptService: this.context.services.conceptService,
                onSelect: this.addAuthor,
                onCreate: this.createAuthor,
                createAllowed: true,
                focusOnRender: true,
                placeholderText
            }).ref('authorSearchComponent')
        } else {
            const AuthorAddComponent = this.context.configurator.getComponent('UIFormAdd')
            searchComponent = $$(AuthorAddComponent, {
                existingItems: this.props.node.authors,
                onSelect: this.addAuthor,
                onCreate: this.createAuthor,
                createAllowed: true,
                focusOnRender: true,
                placeholderText
            }).ref('authorSearchComponent')
        }

        return el.append([
            searchComponent,
            this.renderAuthors($$)
        ])

    }

    renderAuthors($$) {
        const authorList = $$('ul')
            .addClass('dialog-image-authorlist')
            .attr('contenteditable', false)

        for(let n = 0; n < this.props.node.authors.length; n++) {
            const authorItem = this.renderAuthor($$, this.props.node.authors[n])
            if (authorItem) {
                authorList.append(authorItem)
            }
        }

        return $$('div')
            .addClass('dialog-image-authors')
            .append(
                authorList
            )
    }

    renderAuthor($$, author) {
        const Avatar = this.context.configurator.getComponent('UIAvatar')
        const avatarEl = $$(Avatar, {avatarSource: 'gravatar', avatarId: author.email})

        const refId = (NilUUID.isNilUUID(author.uuid)) ? author.name : author.uuid
        return $$('li').append(
            $$('div').append([
                avatarEl,
                $$('div').append([
                    $$('strong').append(author.name),
                    $$('em').append(author.data ? author.data.email ? author.data.email : '' : '')
                ]),
                $$('span').append(
                    $$('a').append(
                        $$(FontAwesomeIcon, {icon: 'fa-times'})
                    )
                        .attr('title', this.getLabel('Remove'))
                        .on('click', function() {
                            this.removeAuthor(author)
                        }.bind(this))
                )
            ])
        ).ref('item-' + refId)
    }

    createAuthor(authorItem) {

        const author = new Author(NilUUID.getNilUUID(), authorItem.inputValue, this.props.node.id)
        try {
            this.props.addAuthor(author, () => {
                this.rerender()
            })
        } catch(e) {
            this.context.api.ui.showNotification('formsearchcomponent', this.getLabel('formsearch.item-exists-label'), this.getLabel('formsearch.item-exists-description'))
            throw e
        }
    }

    addAuthor(authorItem) {
        const authorName = authorItem.name ? authorItem.name[0] : authorItem.ConceptName ? authorItem.ConceptName : ''
        const uuid = authorItem.uuid
        const author = new Author(uuid, authorName, this.props.node.id)

        this.props.addAuthor(author, function() {
            this.rerender()
        }.bind(this))
    }

    removeAuthor(author) {
        const refid = (NilUUID.isNilUUID(author.uuid)) ? author.name : author.uuid
        delete this.refs['item-' + refid]
        this.props.node.removeAuthor(author)
    }

    onClose() {
        return true
    }

}

export {AddToBylineComponent}
